<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> {{$t('pages.dept.breadcrumb')}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container">
            <div>
                <div class="handle-headleft">
                    <el-button type="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">{{$t('pages.dept.add')}}</el-button>
                    <el-button type="danger" icon="el-icon-delete" @click="delAllSelection">{{$t('pages.dept.delete')}}</el-button>
                </div>
                <div class="handle-headright">
                    <el-input v-model="query.Field1" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.dept.codePh')"></el-input>
                    <el-input v-model="query.Field2" @blur="getData()" class="handle-select mr10" :placeholder="$t('pages.dept.namePh')"></el-input>
                    <el-button type="primary" icon="el-icon-search" @click="getData">{{$t('pages.dept.search')}}</el-button>
                </div>
            </div>
            <el-table
                :data="depts"
                row-key="id"
                border
                class="table"
                ref="multipleTable"
                :element-loading-text="$t('pages.dept.loading')"
                v-loading="loading"
                header-cell-class-name="table-header"
                :default-expand-all="true"
                :expand-row-keys="expandRowKeys"
                :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
                @selection-change="handleSelectionChange"
                @row-dblclick="dbSelected"
            >
                <el-table-column type="selection" width="55" align="center"></el-table-column>
                <el-table-column type="index" width="50" :label="$t('pages.dept.index')"></el-table-column>
                <el-table-column sortable prop="code" :label="$t('pages.dept.code')"></el-table-column>
                <el-table-column prop="name" :label="$t('pages.dept.name')"></el-table-column>
                <el-table-column prop="phone" :label="$t('pages.dept.phone')"></el-table-column>
                <el-table-column prop="address" :label="$t('pages.dept.address')" width="300"></el-table-column>
                <el-table-column prop="sort" :label="$t('pages.dept.sort')" width="300"></el-table-column>
                <el-table-column :label="$t('pages.dept.enabled')">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.EnabledFt" @change="changeUse(scope.row)" />
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="enabled" label="是否使用">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.enabled === '1' ? 'primary' : 'danger'" disable-transitions>{{
                            scope.row.enabled | usertypeFormat
                        }}</el-tag>
                    </template>
                </el-table-column>-->
                <!-- <el-table-column prop="modifyUserId" label="操作人"></el-table-column> -->
                <el-table-column sortable prop="modifyDate" :label="$t('pages.dept.operateTime')" width="140">
                    <template slot-scope="scope">{{ scope.row.modifyDate | formateData }}</template>
                </el-table-column>
                <el-table-column :label="$t('pages.dept.actions.edit')" width="180" align="center">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" icon="el-icon-tickets" @click="handleShow(scope.row.id, scope.row)">查看 </el-button> -->
                        <el-button type="text" icon="el-icon-edit" @click="handleEdit(scope.row.id, scope.row)">{{$t('pages.dept.actions.edit')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination background layout="total, prev, pager, next" :current-page="query.PageIndex" :page-size="query.PageSize" :total="pageCount" @current-change="handlePageChange"></el-pagination>
            </div>
        </div>
        <!-- 编辑弹出框 -->
        <el-dialog :title="headTitle" :visible.sync="editVisible" width="50%" :close-on-click-modal="false">
            <el-form ref="dept" :model="dept" :rules="rules" label-width="90px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.dept.fields.code')" prop="code">
                            <el-input v-model="dept.code" :disabled="!isadd"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.dept.fields.name')" prop="name">
                            <el-input v-model="dept.name"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.dept.fields.address')" prop="address">
                            <el-input v-model="dept.address"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.dept.fields.phone')" prop="phone">
                            <el-input v-model="dept.phone"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.dept.fields.leader')" prop="leader">
                            <el-input v-model="dept.leader" class="size-full"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.dept.fields.parent')" prop="parentId">
                            <el-cascader v-model="dept.parentId" :options="deptarr" :props="{ checkStrictly: true }" class="size-full" clearable></el-cascader>
                            <!-- :show-all-levels="false"  只显示选中的，不显示全路径-->
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.dept.fields.sort')" prop="leader">
                            <el-input v-model="dept.sort" class="size-full"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item :label="$t('pages.dept.fields.enabled')" prop="enabled">
                            <el-switch v-model="dept.enabled"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item :label="$t('pages.dept.fields.remark')" prop="remark">
                            <quill-editor ref="myTextEditor" v-model="dept.remark" :options="editorOption"></quill-editor>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">{{$t('pages.dept.dialog.cancel')}}</el-button>
                <el-button type="primary" @click="saveEdit('dept')">{{$t('pages.dept.dialog.confirm')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { SortField, toTree, getchild, IdPath } from '../../utils/helper';
import { quillEditor } from 'vue-quill-editor';
import { listToTree } from '../../utils';
let that;
export default {
    name: 'dept',
    data: function () {
        const checkPass = (rule, value, callback) => {
            if (value !== this.dept.Password) {
                callback(new Error('两次输入密码不一致！'));
            } else {
                callback();
            }
        };
        return {
            expandRowKeys: [],
            headTitle: '',
            isadd: false,
            dept: {},
            editVisible: false,
            depts: [],
            allDepts: [],
            allDeptList: [],
            pageCount: 1,
            multipleSelection: [],
            delList: [],
            loading: false,
            deptarr: [],
            query: {
                Field1: '',
                Field2: '',
                PageIndex: 1,
                PageSize: 15
            },
            editorOption: {
                placeholder: this.$t('pages.dept.rules.nameRequired')
            },
            rules: {
                code: [
                    {
                        required: true,
                        message: this.$t('pages.dept.rules.codeRequired'),
                        trigger: 'blur'
                    },
                    {
                        min: 2,
                        max: 15,
                        message: this.$t('pages.dept.rules.lengthRange'),
                        trigger: 'blur'
                    }
                ],
                name: [
                    {
                        required: true,
                        message: this.$t('pages.dept.rules.nameRequired'),
                        trigger: 'blur'
                    }
                ],

                ip: [
                    {
                        required: true,
                        message: this.$t('pages.dept.rules.ipRequired'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    filters: {
        areaFieldList(dept) {
            return dept.province + '-' + dept.city + '-' + dept.area;
        },
        cloudSpace(dept) {
            return dept.useSpace + '/' + dept.cloudSpace;
        },
        usertypeFormat(UserType) {
            var usertypeName = '';
            if (UserType == '1') {
                usertypeName = '启用';
            } else {
                usertypeName = '停用';
            }
            return usertypeName;
        }
    },
    components: {
        quillEditor
    },
    created() {
        this.getData();
    },
    beforeCreate() {
        that = this;
    },
    methods: {
        saveEdit() {
            this.$refs['dept'].validate((valid) => {
                if (valid) {
                    var parentidPath = this.dept.parentId;
                    var parentid = parentidPath[parentidPath.length - 1];

                    var dpath = IdPath(this.allDepts, parentid, []);
                    if (dpath.length > 3) {
                        this.$notify.warning(this.$t('pages.dept.warn.levelNotAllowed'));
                        return;
                    }
                    this.dept.parentIdPath = dpath.join(',');
                    if (!this.isadd) {
                        var newdata = getchild(this.allDeptList, [this.dept.id], this.dept.id);
                        if (newdata.indexOf(parentid) > -1) {
                            this.$notify.warning(this.$t('pages.dept.warn.parentChangeForbidden'));
                            return;
                        }
                    }
                    this.dept.parentId = parentid;
                    this.dept.enabled = this.dept.enabled ? '1' : '0';
                    if (this.isadd) {
                        this.$zybhttp
                            .post('Dept/DeptAdd', this.dept)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.dept.notify.addSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                    this.dept = {};
                                } else {
                                    this.$notify.error(this.$t('pages.dept.notify.addFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.dept.notify.networkAddError')));
                    } else {
                        this.$zybhttp
                            .post('Dept/DeptUpdate', this.dept)
                            .then((res) => {
                                if (res.data.status == 0) {
                                    this.$notify.success(this.$t('pages.dept.notify.updateSuccess'));
                                    this.getData();
                                    this.editVisible = false;
                                } else {
                                    this.$notify.error(this.$t('pages.dept.notify.updateFail'));
                                }
                            })
                            .catch((err) => this.$notify.error(this.$t('pages.dept.notify.networkUpdateError')));
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getData() {
            // this.loading=true;
            this.$zybhttp
                .post('Dept/GetList', this.query)
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        var userDept = parseInt(JSON.parse(window.localStorage.getItem('ms_userInfo')).deptId);
                        var newdata = getchild(d, [userDept], userDept);
                        d = d.filter((x) => newdata.indexOf(x.id) > -1 && x.id != userDept);
                        //d = d.filter((x) => newdata.indexOf(x.id) > -1 );
                        var newdata = d.sort(SortField('Id', 'desc'));
                        newdata = newdata.map((x) => {
                            x.EnabledFt = x.enabled == '1';
                            x.parentIdOld = x.parentId;
                            return x;
                        }, []);
                        this.expandRowKeys = [];

                        //this.deptarr = toTree(arr);
                        var ndata = listToTree(newdata);

                        this.depts = ndata;
                        this.pageCount = res.data.total || 0;
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.dept.notify.networkListError')));
        },
        getDeptArr() {
            this.$zybhttp
                .post('Dept/GetList', {})
                .then((res) => {
                    if (res.data.status == 0) {
                        res = res.data;
                        var d = res.data.list;
                        this.allDepts = listToTree(d);
                        this.allDeptList = d;
                        var userDept = parseInt(JSON.parse(window.localStorage.getItem('ms_userInfo')).deptId);
                        var newdata = getchild(d, [userDept], userDept);
                        d = d.filter((x) => newdata.indexOf(x.id) > -1);
                        d = d.sort(SortField('id', 'asc'));
                        var arr = [];
                        for (var i = 0; i < d.length; i++) {
                            arr.push({ id: d[i].id, pid: d[i].parentId, value: d[i].id, label: d[i].name });
                        }
                        this.deptarr = toTree(arr);
                    } else {
                        this.$notify.error(res.message);
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.dept.notify.networkListError')));
        },
        changeUse(row) {
            row.enabled = row.EnabledFt ? '1' : '0';
            this.$zybhttp
                .post('Dept/DeptUpdate', row)
                .then((res) => {
                    if (res.data.status == 0) {
                        this.$notify.success(this.$t('pages.dept.notify.updateSuccess'));
                        this.getData();
                    } else {
                        this.$notify.error(this.$t('pages.dept.notify.updateFail'));
                    }
                })
                .catch((err) => this.$notify.error(this.$t('pages.dept.notify.networkUpdateError')));
        },
        handleEdit(id, row) {
            this.getDeptArr();
            this.dept = JSON.parse(JSON.stringify(row));
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.dept.id = id;
            this.editVisible = true;
            this.dept.enabled = this.dept.enabled == '1';
            this.isadd = false;
            var arr = new Array();

            if (this.dept.id != '0') {
                var d = this.dept.parentIdPath.split(',');
                var char = userInfo.deptId;
                if (d.indexOf(char) > -1) {
                    var a = d.slice(d.indexOf(char), d.length);
                    for (var i = 0; i < a.length; i++) {
                        arr.push(parseInt(a[i]));
                    }
                }
            }
            this.dept.parentId = arr;
            this.headTitle = this.$t('pages.dept.dialog.editTitleUpdate');
        },
        dbSelected(row) {
            this.getDeptArr();
            this.dept = JSON.parse(JSON.stringify(row));
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'));
            this.dept.id = row.id;
            this.editVisible = true;
            this.dept.enabled = this.dept.enabled == '1';
            this.isadd = false;
            var arr = new Array();

            if (this.dept.id != '0') {
                var d = this.dept.parentIdPath.split(',');
                var char = userInfo.deptId;
                if (d.indexOf(char) > -1) {
                    var a = d.slice(d.indexOf(char), d.length);
                    for (var i = 0; i < a.length; i++) {
                        arr.push(parseInt(a[i]));
                    }
                }
            }
            this.dept.parentId = arr;
            this.headTitle = this.$t('pages.dept.dialog.editTitleUpdate');
        },
        handleAdd() {
            this.getDeptArr();
            var ms_userInfo = localStorage.getItem('ms_userInfo');
            var userinfo = JSON.parse(ms_userInfo);
            this.dept = {};
            this.isadd = true;
            let date = new Date();
            // this.dept.CreateDate = dateFormat.formatDate(date, 'yyyy-MM-dd hh:mm:ss');
            this.dept.createUserId = userinfo.loginId;
            this.dept.modifyUserId = userinfo.loginId;
            //this.dept.isUse =true;
            this.editVisible = true;
            this.headTitle = this.$t('pages.dept.dialog.editTitleAdd');
        },
        handlePageChange(val) {
            this.$set(this.query, 'PageIndex', val);
            this.getData();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            let strValue = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
                strValue += this.multipleSelection[i].id + ',';
            }
            if (strValue.length == 0) {
                this.$notify.warning(this.$t('pages.dept.notify.deleteSelectedWarning'));
                return;
            }
            this.$confirm(this.$t('pages.dept.notify.deleteConfirm'), this.$t('pages.dept.notify.deleteConfirmTitle'), {
                type: 'warning'
            })
                .then(() => {
                    this.$zybhttp
                        //.get('Dept/DeptDel?ids=1')
                        .get('Dept/DeptDel', {
                            params: { ids: strValue }
                        })
                        .then((res) => {
                            if (res.data.status == 0) {
                                this.$notify.success(this.$t('pages.dept.notify.deleteSuccess', { names: str }));
                                this.getData();
                            } else {
                                this.$notify.error(this.$t('pages.dept.notify.deleteFail'));
                            }
                        })
                        .catch((err) => this.$notify.error(this.$t('pages.dept.notify.networkDeleteError')));
                    this.multipleSelection = [];
                })
                .catch(() => {});
        },
        indexMethod(index) {
            return index + 1;
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-headleft {
    float: left;
    margin-bottom: 15px;
}
.handle-headright {
    float: right;
    margin-bottom: 15px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.size-full {
    width: 100%;
}
</style>

<style>
/* 富文本框高度设置 */
.ql-container {
    min-height: 200px;
    height: 200px;
}
</style>
